import React, {useState, useContext} from "react";
import styles from '.././ProfileEdit.module.sass';
import { ConquerContext } from "../../../contexts/ConquerContext";
import { UserContext } from "../../../contexts/UserContext";
import TextInput from '../../../components/TextInput';
import cn from 'classnames';
import EmailVerificationForm from "../../../components/AuthForms/EmailVerificationForm";
import { ModalContext } from "../../../contexts/Modal/ModalContext";
import { UserContext } from "../../../contexts/UserContext";
import { ConquerContext } from "../../../contexts/ConquerContext";

const EmailSection = () => {

    const conquer = useContext( ConquerContext );
    const userContext = useContext( UserContext );
    const {show, hide} = useContext( ModalContext );
    const [email, setEmail] = useState(userContext.userData.email);
    const [error, setError] =  useState( '' );

    async function tryToChangeEmail(){

        showError('');
        if( !/\S+@\S+\.\S+/.test(email) ) return showError( 'The email doesnt have a valid format' );

        let emailChangeResponse = await conquer.Email.change( email );
        if( emailChangeResponse.error )  return showError( emailChangeResponse.error );
        show( { content: <EmailVerificationForm onFinishCallback={hide} email={email}/>, title: 'Verify Email' } );

    }

    function showError( message ){
        
        setError( message );
        return false;
        
    }

    return (
        <>
            <TextInput
            className={styles.field}
            label='Change Email'
            name='email'
            type='email'
            placeholder='Enter Email'
            onChange={(event) => {setEmail( event.target.value )}}
            required
            value={email}
            />
            {error && <p className={'error'}>{error}</p>}
            <div className="btn_container">
                <button className={'button'} onClick={tryToChangeEmail}>
                    Change Email
                </button>
            </div>
        </>
    )

};

export default EmailSection;